export * from './VariationIcon';
